import { OPTIONS_DEFAULTS } from "@samuelmeuli/font-manager";

import { defaultFilterOptions } from "./utils";

export const UNWANTED_FAMILIES = [
  "Material Icons",
  "Material Icons Rounded",
  "Material Icons Sharp",
  "Material Icons Two Tone",
];

export const DEFAULT_PICKER_PROPS = {
  pickerId: OPTIONS_DEFAULTS.pickerId,
  families: OPTIONS_DEFAULTS.families,
  categories: OPTIONS_DEFAULTS.categories,
  scripts: OPTIONS_DEFAULTS.scripts,
  variants: OPTIONS_DEFAULTS.variants,
  filter: defaultFilterOptions,
  limit: OPTIONS_DEFAULTS.limit,
  sort: OPTIONS_DEFAULTS.sort,
};
